<template>
    <multi-line-view
        ref="multiLine"
        :items="getCardsShowsGenres"
        :line-id="shelfKeys.showsCards"
        :title="title"
        @ready="setStateReady"
        @list-item-selected="itemsSelected"
        @add-list-items="requestMore"
        @leave-up="leaveUp"
    />
    <div v-show="getIsLoadingShows" class="lines-loader">
        <loader />
    </div>
</template>

<script lang="ts" setup>
    import { ref, type Ref, computed, type ComputedRef, watch } from "vue"
    import { useI18n } from "vue-i18n";
    import { Strings } from "@/locales/types/enums";
    import { AppConstants } from "@/common";
    import { useParentControl } from "@/composables/parentControl/useParentControl";
    import { useMultiLinesVodGenresStore } from "@/stores/MultiLinesVodGenres";
    import { storeToRefs } from 'pinia';
    import { useParentControlStore } from "@/stores/ParentControl";
    import type { ExposeInterface } from "./types";
    import type { MultiLineViewRef, IEventSelected } from "@/components/MultiLineView/types";

    const ParentControlStoreModule = useParentControlStore();
    const {
        ShowParentModal,
        SetTargetWidgetAdultControl,
        SetIncorrectAdultPin,
    } = ParentControlStoreModule;
    const {
        getIsAdultPinCorrect: isAdultPinCorrect,
        getTargetWidgetAdultControl: targetWidgetAdultControl,
    } = storeToRefs(ParentControlStoreModule);


    const MultiLinesVodGenresStore = useMultiLinesVodGenresStore();
    const {
        getCardsShowsGenres,
        getIsLoadingShows,
    } = storeToRefs(MultiLinesVodGenresStore);
        const {
        loadShowsGenresNextPage
    } = MultiLinesVodGenresStore;

    const emit = defineEmits(['item-selected', 'leave-up', 'ready']);
    const { t } = useI18n();
    const { setCurrentTimes, checkParentControlCard } = useParentControl();
    const name = "MultiLinesVodGenres";
    const { shelfKeys }: typeof AppConstants = AppConstants;

    const selectedItem: Ref<IEventSelected | null> = ref(null);
    const multiLine: Ref<MultiLineViewRef | null> = ref(null);
    const title: ComputedRef<string> = computed(() => t(Strings.VOD_TV_SHOWS).toString())

    const onListItemSelected = (): void => {
        emit("item-selected", selectedItem.value);
    };
    const itemsSelected = (event: IEventSelected): void => {
        selectedItem.value = event;

        checkParentControlCard(event).then((isAllow)=>{
            if (isAllow) {
                onListItemSelected();
            } else {
                ShowParentModal();
                SetTargetWidgetAdultControl(name);
            }
        }).catch((error)=> {
            Logger.captureError(error)
        });
    };
    const isEmpty = (): boolean => multiLine.value!.isEmpty();
    const setFirstFocused = () => {
        if (multiLine.value) {
            multiLine.value.setFirstFocused();
        }
    };
    const leaveUp = () => {
        emit('leave-up');
    };

    const requestMore = async (): Promise<void> => {
        await loadShowsGenresNextPage();
    };
    const setStateReady = (): void => {
        emit('ready');
    };
    watch(
        isAdultPinCorrect, 
        (value: boolean): void => {
            if (value && name === targetWidgetAdultControl.value) {
                SetIncorrectAdultPin();
                setCurrentTimes();
                onListItemSelected();
            }
        }
    );

    defineExpose<ExposeInterface>({
        setFirstFocused,
        isEmpty
    });
</script>